import { emailVerificationHandler } from 'pages/authPage/sagas/common';
import Api from 'domain/api';

export default emailVerificationHandler(Api.confirmEmailOnEmailChange, '/');
